import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LoginComponent } from './login/login.component';
import { CambiarAccesoComponent } from './cambiar-acceso/cambiar-acceso.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RecuperarCuentaComponent } from './recuperar-cuenta/recuperar-cuenta.component';
import { Error404Component } from './error404/error404.component';
import { ConfigComponent } from './configuracion/config/config.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginService } from './services/login/login.service';

let privilege1 = ['1']


const routes: Routes =[
 
  { path: 'login', component: LoginComponent },
  { path: 'changePassword/:user/:token', component: CambiarAccesoComponent },
  { path: 'recuperarCuenta', component: RecuperarCuentaComponent },
  { path: 'error404', component: Error404Component },
   {
    path: '',
    component: AdminLayoutComponent,
    children: [{
      path: '',
      loadChildren: './layouts/admin-layout/admin-layout.module#AdminLayoutModule'
    }]
  },
  {
    path: '',
    component: ConfigComponent,
    children: [{
      path: 'configuracion',
      loadChildren: './configuracion/config/config-layout.module#ConfigLayoutModule',canActivate: [AuthGuard],data: {privileges: privilege1 }
    }]
  }, 
  {
    path: '**',
    redirectTo: '/error404',
    pathMatch: 'full',
   
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
       useHash: false
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule {

  constructor(private loginService:LoginService ){
    if (performance.navigation.type == PerformanceNavigation.TYPE_RELOAD){
      this.loginService.reloadPermiso = true;
      this.loginService.clickGuard = true;
      if (sessionStorage.getItem("uploadFoto") != null) {
        this.loginService.uploadImage = true;
   }
     }
     window.addEventListener('popstate', function(event) {
      loginService.clickGuard = true;
    }, false);

  }
}



